declare namespace $ {

	export class $shm_codex_app extends $shm_agent_app {
		agent_defaults_namespace( ): string
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map